'use client';

import { useEffect, useState } from "react";
import { ShoppingBag } from "@medusajs/icons";
import { useCart } from "@context/cart-context";
import { useCartDrawer } from "@context/cart-drawer-context";

type CartButtonProps = {
  iconColor?: string;
  hoverColor?: string;
  cartCountColor?: string;
  cartCountTextColor?: string;
};

export default function CartButton({
  iconColor = "var(--storefront-navbar-icon, #000)",
  hoverColor = "var(--storefront-navbar-hover, #000)",
  cartCountColor = "var(--storefront-navbar-cart-count, #ef4444)",
  cartCountTextColor = "#ffffff",
}: CartButtonProps) {
  const { itemCount } = useCart();
  const { open } = useCartDrawer();
  const [isHydrated, setIsHydrated] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <button
      type="button"
      className="transition-colors relative"
      onClick={() => open()}
      data-testid="nav-cart-link"
      aria-label="Abrir carrito"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        color: isHovered ? hoverColor : iconColor,
      }}
    >
      <ShoppingBag className="w-5 h-5" />
      {isHydrated && itemCount > 0 && (
        <span
          className="absolute -top-2 -right-2 text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium"
          style={{
            backgroundColor: cartCountColor,
            color: cartCountTextColor,
          }}
        >
          {itemCount}
        </span>
      )}
    </button>
  );
}
